import { Input } from '@frontapp/ui-kit';
import React, { useState } from 'react';
import SiteInfo from './SiteInfo';
import type { Account, Site } from './types';

type Props = {
  account: Account;
};

function filter(sites: Site[], currentSearch: string) {
  return currentSearch
    ? sites.filter((site) =>
        Object.values(site)
          .join(' ')
          .toLowerCase()
          .includes(currentSearch.toLowerCase()),
      )
    : sites;
}

function Sites({ account }: Props) {
  const [currentSearch, setCurrentSearch] = useState<string>('');

  const ownedSites = account.sites.filter(
    (site) => site.current_account.relationship === 'owner',
  );

  const collaboratorSites = account.sites.filter(
    (site) => site.current_account.relationship === 'collaborator',
  );

  const collaboratorSiteIds = collaboratorSites.map((s) => s.id);

  return (
    <div style={{ margin: '15px 0' }}>
      <div style={{ marginBottom: '15px' }}>
        <Input
          name="info"
          type="text"
          placeholder="Filter projects"
          iconName="Search"
          value={currentSearch}
          onChange={(value) => setCurrentSearch(value)}
        />
      </div>
      <table className="User__sites__table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Ownership</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {filter(ownedSites, currentSearch).map((site) => (
            <SiteInfo key={site.id} site={site} />
          ))}
          {account.organizations.map((organization) => (
            <React.Fragment key={organization.id}>
              {filter(organization.sites, currentSearch)
                .filter((site) => !collaboratorSiteIds.includes(site.id))
                .map((site) => (
                  <SiteInfo
                    key={site.id}
                    site={site}
                    organization={organization}
                  />
                ))}
            </React.Fragment>
          ))}
          {filter(collaboratorSites, currentSearch).map((site) => (
            <SiteInfo key={site.id} site={site} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Sites;
